var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*
    This file is generated with the "identicons" script.
    To update this output make changes to `scripts/svgr/identicon-icon-template.js
    */
import * as React from 'react';
import { IdenticonsCustomProperty, useColorMap, identiconComponentName } from '../common';
import { styled } from '../../styled';
export var IdenticonAuth0LogoLight = styled(function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    var colorMap = useColorMap({
        color: color,
    });
    var fills = {
        light: "var(".concat(IdenticonsCustomProperty.light, ", ").concat(colorMap.light, ")"),
        base: "var(".concat(IdenticonsCustomProperty.base, ", ").concat(colorMap.base, ")"),
        dark: "var(".concat(IdenticonsCustomProperty.dark, ", ").concat(colorMap.dark, ")"),
    };
    return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M24 46c12.15 0 22-9.85 22-22S36.15 2 24 2 2 11.85 2 24s9.85 22 22 22z", fill: fills.light }),
        React.createElement("path", { d: "M15.952 22.52c3.676-.607 6.558-3.65 7.161-7.332l.203-1.77c.05-.281-.14-.673-.495-.645-2.778.217-5.4 1.135-6.857 1.732-.724.297-1.195 1-1.195 1.784v5.773c0 .341.306.602.643.548l.54-.088v-.002zM24.887 15.188c.605 3.682 3.487 6.725 7.161 7.332l.54.088a.554.554 0 00.643-.548v-5.773c0-.784-.47-1.487-1.195-1.784-1.46-.599-4.079-1.515-6.857-1.732-.357-.028-.54.368-.497.645l.203 1.77.002.002zM32.045 24.137c-5.023.992-7.356 4.337-7.356 10.669 0 .317.315.538.58.361 2.31-1.56 7.394-5.634 7.917-10.73.02-.641-.78-.34-1.14-.3zM15.954 24.137c5.023.992 7.356 4.337 7.356 10.669 0 .317-.315.538-.58.361-2.31-1.56-7.394-5.634-7.917-10.73-.02-.641.78-.34 1.14-.3z", fill: fills.dark })));
}, {
    name: identiconComponentName,
})({});
